module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "phytoplankton-algal-blooms--discovery-cover.eab8a78c.jpg";